// extracted by mini-css-extract-plugin
export default {"logo-wrap":"logoArea_logo-wrap__iVL3R"};